"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagKM = function FlagKM(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-185.94-122H209.54a7.06,7.06,0,0,1,7.06,7.06v60H-193v-60a7.06,7.06,0,0,1,7.06-7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "68.09",
    width: "409.6",
    height: "67.09",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "135.18",
    width: "409.6",
    height: "67.09",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-193,79.27H216.6v60a7.06,7.06,0,0,1-7.06,7.06H-185.94A7.06,7.06,0,0,1-193,139.3Zm0,0",
    transform: "translate(194 123)",
    fill: "#4173cd"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-190.4,144.65,7.51,15a3.36,3.36,0,0,0,0-5.62L-190.4-120.29a7,7,0,0,0-2.6,5.35V139.3a7,7,0,0,0,2.6,5.35Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-153.93,12.18A57.36,57.36,0,0,1-114.18-42.4a1.2,1.2,0,0,0-.22-2.33,56.11,56.11,0,0,0-7.25-.48A57.38,57.38,0,0,0-179,12.18a57.38,57.38,0,0,0,57.39,57.39,56.11,56.11,0,0,0,7.25-.48,1.2,1.2,0,0,0,.22-2.33,57.37,57.37,0,0,1-39.75-54.58Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-113.89-31.66l1.58,4.74,5,0a.68.68,0,0,1,.4,1.22l-4,3,1.51,4.76a.67.67,0,0,1-1,.75l-4.07-2.9-4.06,2.9a.67.67,0,0,1-1-.75l1.5-4.76-4-3a.68.68,0,0,1,.39-1.22l5,0,1.58-4.74a.68.68,0,0,1,1.28,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-113.89-7.65l1.58,4.74,5,0a.68.68,0,0,1,.4,1.22l-4,3,1.51,4.77a.67.67,0,0,1-1,.75l-4.07-2.91-4.06,2.91a.67.67,0,0,1-1-.75l1.5-4.77-4-3a.68.68,0,0,1,.39-1.22l5,0,1.58-4.74a.68.68,0,0,1,1.28,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-113.89,16.36l1.58,4.73,5,0a.67.67,0,0,1,.4,1.21l-4,3,1.51,4.76a.67.67,0,0,1-1,.75l-4.07-2.9-4.06,2.9a.67.67,0,0,1-1-.75l1.5-4.76-4-3a.67.67,0,0,1,.39-1.21l5,0,1.58-4.73a.67.67,0,0,1,1.28,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-113.89,40.36l1.58,4.74,5,0a.67.67,0,0,1,.4,1.21l-4,3,1.51,4.76a.67.67,0,0,1-1,.75l-4.07-2.9-4.06,2.9a.67.67,0,0,1-1-.75l1.5-4.76-4-3a.67.67,0,0,1,.39-1.21l5,0,1.58-4.74a.68.68,0,0,1,1.28,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagKM;
exports["default"] = _default;